import React from "react";
//import Routes from "../routes";
import Sidebar from "./Sidebar";
import Topbar from "./topbar/Topbar";

function Layout(props) {
  return (
    <div>
      <Topbar />
      <div style={{ display: "flex" }}>
        <Sidebar history={props.history} />

        {props.children}
      </div>
    </div>
  );
}

export default Layout;
